export enum UserRoleType {
    Presenter = 'presenter',
    Audience = 'audience'
}